module.exports = __webpack_public_path__ + "img/6.a7b8f4c3.webp";